export type DevSeedUserRole = 'Admin' | 'Staff' | 'Rep';

export interface DevSeedUser {
  role: DevSeedUserRole;
  emailAddress: string;
  label: string;
}

export const DEV_LOGIN_OTP_BYPASS_CODE = '333333';

const staffUsers: DevSeedUser[] = Array.from({ length: 40 }, (_, index) => {
  const number = index + 1;
  return {
    role: 'Staff',
    emailAddress: `staff${number}@meetingmd.com`,
    label: `Staff ${number}`,
  };
});

const repUsers: DevSeedUser[] = Array.from({ length: 45 }, (_, index) => {
  const number = index + 1;
  return {
    role: 'Rep',
    emailAddress: `rep${number}@meetingmd.com`,
    label: `Rep ${number}`,
  };
});

export const DEV_SEED_USERS: DevSeedUser[] = [
  {
    role: 'Admin',
    emailAddress: 'admin@meetingmd.com',
    label: 'Admin',
  },
  ...staffUsers,
  ...repUsers,
];
